export function Tag({ children, variant = "default", testId }) {
  const base =
    "inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-medium border";
  const styles = {
    default: "border-[#141B4D]/20 bg-white text-[#141B4D]",
    accent: "border-[#FFD100] bg-[#FFD100] text-[#141B4D]",
    active: "border-emerald-300 bg-emerald-50 text-emerald-700",
    retired: "border-[#141B4D]/20 bg-[#141B4D]/5 text-[#141B4D]/60",
    evergreen: "border-emerald-300 bg-emerald-50 text-emerald-700",
    "time-sensitive": "border-amber-300 bg-amber-50 text-amber-800",
    stale: "border-rose-300 bg-rose-50 text-rose-700",
  };
  return (
    <span data-testid={testId} className={`${base} ${styles[variant] || styles.default}`}>
      {children}
    </span>
  );
}
